<template>
    <article itemprop="articleBody">
        <header>
            <h1>Dein Lerncheck</h1>
            <p>Die nächste Klassenarbeit steht an und du bist dir noch unsicher, wie gut du bereits vorbereitet bist? Teste jetzt dein Wissen und ermittle deine Lernlücken!</p>
        </header>
        <form class="form-container">
              <div class="stufe">
                <strong>In welcher Klassenstufe befindest du dich?</strong>
                <div class="field-container">
                  <i role="presentation" class="open-indicator"></i>
                  <select class="default-select" v-model="select_level" v-on:change="loadCategories()">
                    <option value="" disabled="disabled" selected="selected">Deine Klassenstufe</option>
                    <option v-for="level in levels" v-bind:value="level.name">{{ level.name }}</option>
                  </select>
                </div>
              </div>
              <div v-if="categories.length > 0" class="fach">
                <strong>In welchem Fach möchtest du dein Wissen testen?</strong>
                <div class="field-container">
                  <i role="presentation" class="open-indicator"></i>
                    <select class="default-select" v-model="select_category" v-on:change="loadTopics()">
                      <option value="" disabled="disabled" selected="selected">Dein Fach</option>
                      <option v-for="category in categories" v-bind:value="category.name">{{ category.name }}</option>
                    </select>
                </div>
            </div>
            <div v-if="topics.length > 0" class="fach">
                <strong>Bitte wähle ein Thema:</strong>
                <div class="field-container">
                  <i role="presentation" class="open-indicator"></i>
                    <select class="default-select" v-model="select_topic">
                      <option value="" disabled="disabled" selected="selected">Dein Thema</option>
                      <option v-for="topic in topics" v-bind:value="topic.name">{{ topic.name }}</option>
                    </select>
                </div>
            </div>
            <div v-if="select_topic" class="mail">
              <strong>Deine Email-Adresse</strong>
              <div class="field-container">
                <input type="email" v-model="email">
              </div>
              <div class="opt-in">
                  <input class="regular-checkbox" type="checkbox" id="checkbox" v-model="accept_terms" required/>
                  <label for="checkbox">
                      <span>Ja, ich habe die <router-link target="_blank" :to="{ name: 'teilnahmebedingungen' }">Teilnahmebedingungen</router-link> gelesen und möchte über Möglichkeiten zur weiteren Prüfungsvorbereitung informiert werden.</span>
                  </label>
              </div>
            </div>
            <div class="buttons">
                <button type="button" @click="startExam()">
                    <span>Lerncheck starten</span>
                    <i class="fa fa-angle-right right" aria-hidden="true"></i>
                </button>
            </div>

         </form>
    </article>
</template>

<style language="scss" scoped>
button {
  margin-left:0;
}
</style>

<script>
import axios from 'axios';
import config from '../config.js';

export default {
    data: function() {
        return {
            loading: true,
            select_level: null,
            select_category: null,
            select_topic: null,
            accept_terms: false,
        }
    },
    mounted: function() {
        this.loadLevels();
    },
    methods: {
      loadLevels: function () {
        this.select_level = null;
        this.levels = [];
        axios.get(config.api_url + '/levels', {
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(response => {
            this.levels = response.data.data
          });
      },
      loadCategories: function () {
        this.select_category = null;
        this.select_topic = null;
        this.topics = [];
        axios.get(config.api_url + '/categories/' + encodeURI(this.select_level), {
          headers: {
            'Accept': 'application/json'
          }
        })
          .then(response => {
            this.categories = response.data.data
          });
      },
        loadTopics: function () {
            axios
                .get(config.api_url + '/topics/' + encodeURI(this.select_level) + "/" + encodeURI(this.select_category), {
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => {
                    this.topics = response.data.data
                });
        },
        startExam: function () {
            if (this.ready) {
                const postData = {
                    "user": {
                        "email": this.email
                    },
                    "level": {
                        "name": this.select_level
                    },
                    "category": {
                        "name": this.select_category
                    },
                    "topic": {
                        "name": this.select_topic
                    }
                };
                axios.post(
                    config.api_url + '/exam/create',
                    postData
                )
                .then((response) => {
                    this.exam = response.data;
                    fbq('track', 'Lead', {
                        'content_name': this.select_category,
                        'content_category': this.select_level
                    });
                    if (this.exam.uid) {
                        this.$router.push({ name: 'exam', params: { uid: this.exam.uid } })
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            }
        },
    },
    computed: {
        ready () {
            const level_rdy = this.select_level != null && this.select_level !== '';
            const category_rdy = this.select_category != null && this.select_cateogry !== '';
            const topic_rdy = this.select_topic != null && this.select_topic !== '';
            const email_rdy = this.email != null && this.email !== '';
            return level_rdy && category_rdy && topic_rdy && email_rdy && this.accept_terms;
        },
        email: {
          get() {
            return this.$store.getters.email;
          },
          set(value) {
            this.$store.dispatch('updateEmail', value);
          }
        },
        topics: {
            get () {
                return this.$store.getters.topics;
            },
            set (value) {
                this.$store.dispatch('updateTopics', value)
            }
        },
        categories: {
            get () {
                return this.$store.getters.categories;
            },
            set (value) {
                this.$store.dispatch('updateCategories', value)
            }
        },
        levels: {
            get () {
                return this.$store.getters.levels;
            },
            set (value) {
                this.$store.dispatch('updateLevels', value)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SelectCategory.vue